import { gsapSingleton, scrollTriggerSingleton, splitTextSingleton } from "../gsap";
import $ from 'jquery';
import Component from '../models/Component';

const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();
const SplitText = splitTextSingleton();

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class ColorText extends Component {
  constructor(element, context) {
    super(element, context);

    $(() => {
      const animatedText = this.element.find('h2');
      const mySplitText = new SplitText(animatedText, { type: "words,chars" });
      const chars = mySplitText.chars;

      gsap.fromTo(
        chars,
        {
          color: "#DED8CD"
        },
        {
          color: "#6D3A1F",
          stagger: 0.1,
          scrollTrigger: {
            trigger: animatedText,
            start: "top 80%",
            end: "top top",
            toggleActions: "play none none reverse",
            markers: false,
            scrub: 1,
          }
        }
      );
    });
  }
}
